(function() {
  'use strict';

  function addProductButton(product) {
    const productCard = document.querySelector(`[data-product="${product}"]`);
    if(!productCard) {
        return;
    }
    const title = productCard.querySelector('.card__title a')?.textContent || 'Product';
    const image = productCard.querySelector('img')?.src || document.querySelector('meta[property="og:image"]')?.content;
    const inputMaxQty = productCard.querySelector('input[name="properties[_rpq]"]');
    const maxQuantity = inputMaxQty.value ? parseInt(inputMaxQty.value) : 0;
    const productInfo = {
        title: title.trim(),
        image: image,
        variant: null
    }
    const message = getQuantityLimitMessage('max-reached', { maxQuantity });
    showQuantityModal(message, productInfo);
  }
  window.addProductButton = addProductButton;
  
  function getQuantityLimitMessage(template, values) {
    const templateElement = document.querySelector(`[data-template="${template}"]`);
    if (!templateElement) return 'Error: Template not found';
    
    let message = templateElement.textContent;
    
    if (values.maxQuantity !== undefined) {
      message = message.replace(/MAX_QTY_PLACEHOLDER/g, values.maxQuantity);
    }
    if (values.currentQuantity !== undefined) {
      message = message.replace(/CURRENT_QTY_PLACEHOLDER/g, values.currentQuantity);
    }
    if (values.allowedQuantity !== undefined) {
      message = message.replace(/ALLOWED_QTY_PLACEHOLDER/g, values.allowedQuantity);
    }
    if (values.requestedQuantity !== undefined) {
      message = message.replace(/REQUESTED_QTY_PLACEHOLDER/g, values.requestedQuantity);
    }
    
    return message;
  }
  
  function showQuantityModal(message, productInfo = null) {
    document.getElementById('quantity-modal-message').textContent = message;
    
    const productElement = document.getElementById('quantity-modal-product');
    if (productInfo && productInfo.title) {
      document.getElementById('quantity-modal-product-title').textContent = productInfo.title;
      document.getElementById('quantity-modal-product-variant').textContent = productInfo.variant || '';
      document.getElementById('quantity-modal-product-image').src = productInfo.image || '';
      document.getElementById('quantity-modal-product-image').alt = productInfo.title;
      productElement.style.display = 'flex';
    } else {
      productElement.style.display = 'none';
    }
    
    document.getElementById('quantity-limit-modal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  
  function closeQuantityModal() {
    document.getElementById('quantity-limit-modal').style.display = 'none';
    document.body.style.overflow = '';
  }
  
  window.closeQuantityModal = closeQuantityModal;
  
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('quantity-modal-overlay')) {
      closeQuantityModal();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.getElementById('quantity-limit-modal').style.display === 'block') {
      closeQuantityModal();
    }
  });
  
  const originalFetch = window.fetch;
  
  window.fetch = async function(...args) {
    let [url, options] = args;
    
    if(url instanceof URL){
      url = url.href;
    }
    
    if (url && (url.includes('add.js') || url.includes('/cart/add'))) {
        if (options && options.body) {
        try {
          let requestData = {};
          
          // Handle different body types
          if (typeof options.body === 'string') {
            requestData = JSON.parse(options.body);
          } else if (options.body instanceof FormData) {
            // Convert FormData to object
            for (const [key, value] of options.body.entries()) {
              // Handle nested properties like properties[_rpq]
              if (key.startsWith('properties[') && key.endsWith(']')) {
                if (!requestData.properties) requestData.properties = {};
                const propKey = key.slice(11, -1); // Remove 'properties[' and ']'
                requestData.properties[propKey] = value;
              } else {
                requestData[key] = value;
              }
            }
          } else {
            // Handle URLSearchParams or other formats
            const params = new URLSearchParams(options.body);
            for (const [key, value] of params) {
              requestData[key] = value;
            }
          }
          
          if (requestData.properties && requestData.properties._rpq && requestData.quantity && requestData.id) {
            const maxQuantity = parseInt(requestData.properties._rpq);
            const requestedQuantity = parseInt(requestData.quantity);
            const variantId = requestData.id;
            
            try {
              const cartResponse = await originalFetch('/cart.js');
              const cart = await cartResponse.json();
              let currentQuantityInCart = 0;
              if (cart.items) {
                const existingItem = cart.items.find(item => item.variant_id == variantId);
                if (existingItem) {
                  currentQuantityInCart = existingItem.quantity;
                }
              }
              
              const totalAfterAdd = currentQuantityInCart + requestedQuantity;
              
              if (totalAfterAdd > maxQuantity) {
                const allowedToAdd = Math.max(0, maxQuantity - currentQuantityInCart);
                
                let productInfo = null;
                const productElement = document.querySelector(`[data-variant-id="${variantId}"]`) || 
                                     document.querySelector(`input[name="id"][value="${variantId}"]`);
                
                if (productElement) {
                  const productContainer = productElement.closest('[data-product-title]') || 
                                         productElement.closest('.product') || 
                                         productElement.closest('.card');
                  
                  if (productContainer) {
                    const title = productContainer.getAttribute('data-product-title') || 
                                 productContainer.querySelector('h1, h2, h3, .product-title')?.textContent || 
                                 document.title;
                    const image = productContainer.querySelector('img')?.src || 
                                 document.querySelector('meta[property="og:image"]')?.content;
                    
                    productInfo = {
                      title: title.trim(),
                      image: image,
                      variant: null
                    };
                  }
                }
                
                if (allowedToAdd <= 0) {
                  const message = getQuantityLimitMessage('max-reached', { maxQuantity });
                  showQuantityModal(message, productInfo);
                  
                  // Update the body based on its original format
                  if (typeof options.body === 'string') {
                    requestData.quantity = '0';
                    options.body = JSON.stringify(requestData);
                  } else if (options.body instanceof FormData) {
                    options.body.set('quantity', '0');
                  }
                } else {
                  const message = getQuantityLimitMessage('adjusted-add', { 
                    maxQuantity, 
                    currentQuantity: currentQuantityInCart, 
                    allowedQuantity: allowedToAdd, 
                    requestedQuantity 
                  });
                  showQuantityModal(message, productInfo);
                  
                  // Update the body based on its original format
                  if (typeof options.body === 'string') {
                    requestData.quantity = allowedToAdd.toString();
                    options.body = JSON.stringify(requestData);
                  } else if (options.body instanceof FormData) {
                    options.body.set('quantity', allowedToAdd.toString());
                  }
                }
              }
            } catch (cartError) {
              if (requestedQuantity > maxQuantity) {
                let productInfo = {
                  title: document.title || 'Product',
                  image: document.querySelector('meta[property="og:image"]')?.content,
                  variant: null
                };
                
                const message = getQuantityLimitMessage('adjusted-change', { maxQuantity, requestedQuantity });
                showQuantityModal(message, productInfo);
                
                // Update the body based on its original format
                if (typeof options.body === 'string') {
                  requestData.quantity = maxQuantity.toString();
                  options.body = JSON.stringify(requestData);
                } else if (options.body instanceof FormData) {
                  options.body.set('quantity', maxQuantity.toString());
                }
              }
            }
          }
        } catch (e) {
        }
      }
    }
    
    if (url && (url.includes('change.js') || url.includes('/cart/change'))) {
      if (options && options.body) {
        try {
          let requestData = {};
          
          // Handle different body types
          if (typeof options.body === 'string') {
            if (options.body.startsWith('{') || (options.headers && 
                (options.headers['Content-Type'] === 'application/json' || 
                 options.headers['content-type'] === 'application/json'))) {
              requestData = JSON.parse(options.body);
            } else {
              const params = new URLSearchParams(options.body);
              for (const [key, value] of params) {
                requestData[key] = value;
              }
            }
          } else if (options.body instanceof FormData) {
            // Convert FormData to object
            for (const [key, value] of options.body.entries()) {
              requestData[key] = value;
            }
          } else {
            // Handle URLSearchParams or other formats
            const params = new URLSearchParams(options.body);
            for (const [key, value] of params) {
              requestData[key] = value;
            }
          }
          
          if (requestData.line && requestData.quantity) {
            const lineIndex = parseInt(requestData.line);
            const newQuantity = parseInt(requestData.quantity);
            
            try {
              const cartResponse = await originalFetch('/cart.js');
              const cart = await cartResponse.json();
              
              if (cart.items && cart.items[lineIndex - 1]) {
                const item = cart.items[lineIndex - 1];
                
                if (item.properties && item.properties._rpq) {
                  const maxQuantity = parseInt(item.properties._rpq);
                  
                  if (newQuantity > maxQuantity) {
                    const productInfo = {
                      title: item.product_title || item.title || 'Product',
                      image: item.image || item.featured_image?.url,
                      variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null
                    };
                    
                    const message = getQuantityLimitMessage('adjusted-change', { maxQuantity, requestedQuantity: newQuantity });
                    showQuantityModal(message, productInfo);
                    
                    // Update the body based on its original format
                    if (typeof options.body === 'string') {
                      if (options.body.startsWith('{')) {
                        requestData.quantity = maxQuantity.toString();
                        options.body = JSON.stringify(requestData);
                      } else {
                        const params = new URLSearchParams(options.body);
                        params.set('quantity', maxQuantity.toString());
                        options.body = params.toString();
                      }
                    } else if (options.body instanceof FormData) {
                      options.body.set('quantity', maxQuantity.toString());
                    }
                  }
                }
              }
            } catch (cartError) {
            }
          }
        } catch (e) {
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };
})();